import { NE_SEARCH_ITEMS } from '@doda/common/src/constants/searchItems';
import { findJobCount } from 'components/IndustryModal/logics/createIndustryDisplayData';
import { EmployNumListType } from 'types/kodawari';
import { HooksArgument } from 'components/SearchSideBar/types';
import { getInitialIdList } from '../getInitialIdList';

/**
 * 従業員数の初期状態を生成
 * @param param.savedSearchCondition 保存した検索条件のレスポンス
 * @param param.featuredSearchCondition 特集枠検索条件のレスポンス
 * @param param.queries クエリパラメータ
 * @param param.jobCountData 求人件数
 * @returns 従業員数の初期配列
 */
export const createInitialEmployNumList = ({
  savedSearchCondition,
  featuredSearchCondition,
  queries,
  jobCountData,
}: HooksArgument) => {
  const paramList = getInitialIdList({
    savedSearchCondition,
    featuredSearchCondition,
    queries,
  });

  const initialData: EmployNumListType[] = NE_SEARCH_ITEMS.map((item) => ({
    id: item.id,
    name: item.name,
    isChecked: paramList.some((query) => query === item.id),
    value: item.id as EmployNumListType['value'],
    jobCount: findJobCount(jobCountData.employNumList, item.id),
  }));

  return initialData;
};
